<script lang="ts" setup>
	import moment from 'moment'

	interface Props {
		startDate: string
		endDate: string
	}

	const props = defineProps<Props>()

	const nights = moment(props.endDate).diff(moment(props.startDate), 'days')
	const nightsLabel = nights > 1 ? 'noches' : 'noche'
</script>

<template>
	<div class="bg-white px-4 lg:px-6 py-3 lg:py-4 border-b border-gray-200">
		<div class="flex items-center justify-between mb-2 lg:mb-3">
			<div class="text-center">
				<div class="text-xs text-gray-500 font-inter uppercase tracking-wide">
					{{ moment(startDate).format('MMM') }}
				</div>
				<div class="text-xl lg:text-2xl font-inter font-bold text-gray-900">
					{{ moment(startDate).format('D') }}
				</div>
			</div>
			<div class="flex flex-col items-center">
				<svg
					class="w-5 h-5 lg:w-6 lg:h-6 text-gray-400"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M17 8l4 4m0 0l-4 4m4-4H3"
					></path>
				</svg>
				<span class="text-xs text-gray-600 font-inter mt-1">
					{{ nights }} {{ nightsLabel }}
				</span>
			</div>
			<div class="text-center">
				<div class="text-xs text-gray-500 font-inter uppercase tracking-wide">
					{{ moment(endDate).format('MMM') }}
				</div>
				<div class="text-xl lg:text-2xl font-inter font-bold text-gray-900">
					{{ moment(endDate).format('D') }}
				</div>
			</div>
		</div>
	</div>
</template>
